import { useSelector } from "react-redux";
import { AppState } from "store";

export const useCouponList = () =>
  useSelector((state: AppState) => state.coupon.list);

export const useCouponListLoading = () =>
  useSelector((state: AppState) => state.coupon.loading);
